import {
  Component,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { APIService } from '../../../../../api/api.service';
import { NotifierService } from '../../../../../_services/notifier.service';
import { regions } from './../../../../../dash/dash.component';

declare let $: any;
declare let flatpickr: any;

@Component({
  selector: 'mrr-enablecfrc-update',
  templateUrl: './update.enableri.component.html',
  styleUrls: ['./update.enableri.component.css'],
})
export class MrrEnableCFRCUpdateComponent implements OnInit, OnDestroy {
  additionalContacts: string[] = [''];
  userId = localStorage.getItem('eId');
  ut = localStorage.getItem('ut');
  regions: any = regions;
  urlPrefix: any = localStorage.getItem('role') == 'Admin' ? 'admin' : 'client';
  writeAccess: boolean =
    localStorage.getItem('acT') == 'readandwrite' ||
    this.urlPrefix == 'admin' ||
    localStorage.getItem('ut') == 'admin';
  loading = true;
  accountId: any;
  regionId: any;
  dateRange: any;
  selectAll: boolean = false;
  RITypes: any = [];
  currentMessage: any;
  @Input() ri: any = {
    regionn: [],
    usageType: [],
    linkedAccounts: [],
    discountType: 'percentage',
    discountPercentage: '',
    unit: '',
    ppu: '',
    description: '',
  };
  @Input() action: any;
  @Input() childs: any[] = [];
  @Output() hideModel = new EventEmitter<any>();
  instanceTypes: any;
  platformTypes: any;
  linkedAccounts: any = {};
  selectedAccounts: any;
  accounts: any;
  constructor(
    private apiService: APIService,
    private notifier: NotifierService,
  ) {}

  ngOnInit(): void {
    // Guard: ensure ri always has array defaults before template renders
    this.ri = {
      regionn: [],
      usageType: [],
      linkedAccounts: [],
      discountType: 'percentage',
      discountPercentage: '',
      unit: '',
      ppu: '',
      description: '',
      ...this.ri, // passed @Input values override defaults
    };

    $('#cfrc_regions_reg').selectpicker();
    setTimeout(() => {
      $('#cfrc_regions_reg').selectpicker('refresh');
      $('#cfrc_platformsList').selectpicker('refresh');
    }, 1000);

    this.accountId = localStorage.getItem('accountId');
    this.regionId = localStorage.getItem('regionId');
    this.linkedAccounts = JSON.parse(
      localStorage.getItem('accountIdData') || '{}',
    );
    if (Array.isArray(this.linkedAccounts.list)) {
      this.accounts = this.linkedAccounts.list.map(
        (accountObj: any) => accountObj.account,
      );
    } else {
      console.error(
        'linkedAccounts does not have a valid list key or it is not an array.',
      );
    }

    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let d = JSON.parse(msg);
      if (d.value == null) return;
      if (d.key == 'accountId') {
        this.accountId = d.value;
        this.load();
      } else if (d.key == 'regionId') {
        this.regionId = d.value;
        this.load();
      } else if (d.key == 'accountIdData') {
        this.linkedAccounts = d.value;
        this.load();
      }
    });

    flatpickr('#cfrc_dataRangePicker', {
      dateFormat: 'Y-m-d',
      mode: 'range',
      showMonths: 2,
      defaultDate: this.dateRange ? this.dateRange.split(' to ') : null,
      onChange: (selectedDates: any, dateStr: any, instance: any) => {
        if (!dateStr.includes('to')) return;
        this.dateRange = dateStr;
      },
    });

    if (this.action == 'update') {
      if (this.ri.discountType == 'value') {
        this.disc = this.ri.discount;
      } else {
        this.disc = this.ri.discountPercentage;
      }
      this.dateRange = this.ri.startDate + ' to ' + this.ri.endDate;
      if (this.ri.usageType == 'all') {
        this.selectAll = true;
      }
    }
  }
  disc: any;
  load() {
    this.fetchInstanceTypes();
    if (this.action == 'update' && this.ri.usageType !== 'all') {
      this.fetchPlatformsTypes();
    }
    // this.fetchRITypes();
    // this.fetchPlatformsTypes();
  }
  validateNumericInput(event: KeyboardEvent): void {
    // Allow only numeric characters (0-9) and control keys (backspace, delete, arrows)
    const allowedKeys = [
      'Backspace',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
      'Tab',
    ];
    if (allowedKeys.includes(event.key)) {
      return; // Allow control keys
    }

    // Block any non-numeric keys
    const isNumeric = /^[0-9]$/.test(event.key);
    if (!isNumeric) {
      event.preventDefault();
    }
  }

  selectAllRegions(event: any) {
    if (event.target.checked) {
      this.ri.regionn = this.regions_reg.map((region: any) => region);
    } else {
      this.ri.regionn = [];
    }
    this.fetchPlatformsTypes();
    setTimeout(() => {
      $('#cfrc_regions_reg').selectpicker('refresh'); // ← was regions_reg
    }, 10);
  }

  selectAllchilds(event: any) {
    const isChecked = event.target.checked;

    if (isChecked) {
      // Select all accounts
      this.ri.linkedAccounts = this.linkedAccounts['list'].map(
        (account: any) => account.accountId,
      );
    } else {
      // Deselect all accounts
      this.ri.linkedAccounts = [];
    }
    setTimeout(() => {
      $('#linkedAccounts').selectpicker('refresh');
    }, 10);
  }

  selectFiltertedRegions(event: Event) {
    let input = document
      .querySelector('#cfrc_regions_reg') // ← was #regions_reg
      .parentElement.querySelector('.dropdown-menu')
      .querySelector('input');

    if (input.value.trim() == '') return;

    this.ri.regionn = this.regions_reg.filter(
      (region: any) =>
        region.toLowerCase().indexOf(input.value.toLowerCase()) > -1,
    );
    this.fetchPlatformsTypes();
    setTimeout(() => {
      $('#cfrc_regions_reg').selectpicker('refresh'); // ← was regions_reg
    }, 10);
  }

  selectAllUsageTypes(event: any) {
    if (event.target.checked) {
      this.ri.usageType = this.usageType.map((platform: any) => platform);
    } else {
      this.ri.usageType = [];
    }
    setTimeout(() => {
      $('#cfrc_platformsList').selectpicker('refresh'); // ← was platformsList
    }, 10);
  }

  selectFiltertedUsageTypes(event: Event) {
    let input = document
      .querySelector('#cfrc_platformsList') // ← was #platformsList
      .parentElement.querySelector('.dropdown-menu')
      .querySelector('input');

    if (input.value.trim() == '') return;

    this.ri.usageType = this.usageType.filter(
      (platform: any) =>
        platform.toLowerCase().indexOf(input.value.toLowerCase()) > -1,
    );
    setTimeout(() => {
      $('#cfrc_platformsList').selectpicker('refresh'); // ← was platformsList
    }, 10);
  }

  onSelectAllChange() {
    this.ri.usageType = this.selectAll ? 'all' : '';
  }
  async fetchRICost() {
    if (this.ri.regionn.length > 1 || this.ri.usageType.length > 1) {
      return;
    } else if (this.ri.usageType.length !== 0) {
      let region: string = $('#regionn').val();
      let usageType: string = $('#usageType').val();
      this.notifier.loading(true);
      let data = {
        action: 'getUsageTypeDetails',
        usageType: this.ri.usageType[0].split('_')[0],
        region: this.ri.regionn[0],
      };
      let header = {
        Authorization: localStorage.getItem('t'),
      };

      let apiURL =
        'https://dev.api.swayam.cloud/v3/admin/billing/cfrc-enable-v3';
      let result = await this.apiService.postDataPromis(apiURL, data, header);
      if (result.status == '1' || result.s == '1') {
        let response;
        response = result.data[0];
        this.ri = {
          ...this.ri,
          description: response.description,
          discount: response.discount,
          // regionn: response.regionn,
          // usageType: response.usageType,
          unit: response.unit,
          ppu: response.ppu,
        };
      } else {
        this.notifier.alert('Info', '', result.msg, 'info', 5000);
      }

      this.notifier.loading(false);
    }
  }
  regions_reg: any;
  async fetchInstanceTypes() {
    this.notifier.loading(true);
    let data = { action: 'fetchUniqueRegions' };

    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `https://dev.api.swayam.cloud/v3/admin/billing/cfrc-enable-v3`;

    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.status == '1' || result.s == '1') {
      this.regions_reg = result.regions;
      setTimeout(() => {
        $('#cfrc_regions_reg').selectpicker('refresh'); // ← was regions_reg
      }, 100);
    } else {
      this.notifier.alert('Info', '', result.error, 'info', 5000);
    }
    this.notifier.loading(false);
  }

  usageType: any;
  async fetchPlatformsTypes() {
    this.notifier.loading(true);
    let data = {
      action: 'getRegionWiseUsageTypes',
      regionList: this.ri.regionn,
    };

    let header = {
      Authorization: localStorage.getItem('t'),
    };
    //https://api.swayam.cloud/v3/admin/support
    let apiURL = `https://dev.api.swayam.cloud/v3/admin/billing/cfrc-enable-v3`;

    let result = await this.apiService.postDataPromis(apiURL, data, header);
    if (result.status == '1' || result.s == '1') {
      this.usageType = result.usageType;
      setTimeout(() => {
        $('#cfrc_platformsList').selectpicker('refresh'); // ← was platformsList
      }, 100);
    } else {
      this.notifier.alert('Info', '', result.error, 'info', 5000);
    }
    this.notifier.loading(false);
  }
  isFormValid() {
    return (
      !!this.ri.regionn &&
      !!this.ri.usageType &&
      !!this.ri.discountPercentage &&
      !!this.ri.unit &&
      !!this.ri.ppu
    );
  }
  showInvalidFieldNotification() {
    if (this.ri.regionn.length === 0) {
      this.notifier.alert('Error', '', 'Region is required', 'error', 5000);
      return;
    }
    if (this.ri.usageType.length === 0) {
      this.notifier.alert('Error', '', 'Usage Type is required', 'error', 5000);
      return;
    }
    if (!this.ri.discountPercentage) {
      this.notifier.alert('Error', '', 'Discount is required', 'error', 5000);
      return;
    }
  }
  childStatusList: any[] = [];

  getDisplayName(type: string): string {
    return type.split('_')[0];
  }
  ngOnDestroy(): void {}

  trackByFn() {
    return true;
  }
  showInvalidFieldNotificationall() {
    if (!this.ri.usageType) {
      this.notifier.alert('Error', '', 'Usage Type is required', 'error', 5000);
      return;
    }
    if (!this.ri.discountPercentage) {
      this.notifier.alert('Error', '', 'Discount is required', 'error', 5000);
      return;
    }
    if (this.dateRange == '' || this.dateRange == undefined) {
      this.notifier.alert('Info', '', 'Please select date range', 'info', 500);
      return;
    }
  }

  statusclose() {
    this.childStatusList = [];
    this.close(true);
  }

  getFormData(): { isValid: boolean; data?: any; errors: string[] } {
    const errors: string[] = [];

    if (this.action !== 'update') {
      // ADD flow
      if (!this.selectAll) {
        if (!this.ri.regionn || this.ri.regionn.length === 0)
          errors.push('Region is required');
        if (!this.ri.usageType || this.ri.usageType.length === 0)
          errors.push('Usage Type is required');
      }
      if (
        !this.ri.discountPercentage ||
        !/^\d+(\.\d+)?$/.test(this.ri.discountPercentage)
      )
        errors.push('Discount is required and must be numeric');
      if (!this.dateRange) errors.push('Please select a date range');
      if (!this.childs || this.childs.length === 0)
        errors.push('At least one child account must be selected');

      if (errors.length > 0) return { isValid: false, errors };

      const [startDate, endDate] = this.dateRange
        .split('to')
        .map((d: string) => d.trim());
      const isMultiple =
        !this.selectAll &&
        (this.ri.regionn.length > 1 || this.ri.usageType.length > 1);

      if (isMultiple) {
        return {
          isValid: true,
          errors: [],
          data: {
            action: 'addMultiple',
            tableType: 'cfrc',
            childIds: this.childs,
            regionList: this.ri.regionn,
            usageTypelist: this.ri.usageType,
            startDate,
            endDate,
            discountType: this.ri.discountType,
            discount: this.ri.discountPercentage,
            ppu: this.ri.ppu ?? '',
            isMultiple: true,
          },
        };
      }

      // single add (or selectAll)
      const usageType = this.selectAll
        ? 'all'
        : this.ri.usageType[0].split('_')[0];
      const regionn = this.selectAll ? '' : this.ri.regionn[0];

      return {
        isValid: true,
        errors: [],
        data: {
          action: 'add',
          tableType: 'cfrc',
          childIds: this.childs,
          data: [
            {
              regionn,
              description: this.ri.description,
              ppu: this.ri.ppu ?? '',
              discountType: this.ri.discountType,
              unit: this.ri.unit ?? '',
              usageType,
              discount: this.ri.discountPercentage,
              startDate,
              endDate,
            },
          ],
        },
      };
    }

    // UPDATE flow
    if (!this.disc) errors.push('Discount is required');
    if (errors.length > 0) return { isValid: false, errors };

    return {
      isValid: true,
      errors: [],
      data: {
        action: 'update',
        tableType: 'cfrc',
        data: [
          {
            accountId: this.ri.accountId,
            uuid: this.ri.uuid,
            discountType: this.ri.discountType,
            discount: this.disc,
            ppu: this.ri.ppu ?? '',
            usageType: this.ri.usageType,
          },
        ],
      },
    };
  }

  close(dataAction: any) {
    if (dataAction) {
      this.hideModel.emit(dataAction);
    } else {
      this.hideModel.emit(dataAction);
    }
  }
}